<template>
      <!-- TODO: hacking here - if tenant is Asia, show large layout -->
      <core-layout-content
            :large="
			$store.state.tenantId === 'asia_uat' || $store.state.tenantId === 'asia' || $store.state.tenantId === 'demo2_uat'
		"
            medium
      >
            <core-layout-headline-and-actions>
                  <template slot="headline">{{ $t("create_quote") }}</template>
            </core-layout-headline-and-actions>

            <!-- TODO: hacking here -->
            <!-- When tenant is asia or asia_uat, show special application -->
            <asia-application
                  v-if="
				$store.state.tenantId === 'asia_uat' || $store.state.tenantId === 'asia' || $store.state.tenantId === 'demo2_uat'
			"
            />

            <!-- Body -->
            <j-card class="xs-12 bg5 r2 p4" v-else>
                  <!-- Client -->
                  <div class="xs-12">
                        <label class="xs-12 lh125 fw7 mb1" for="client">{{ $t("select_client") }}</label>
                        <core-select-client
                              id="client"
                              name="client"
                              v-model="form.holders"
                              :clientType="form.clientType"
                              @clientTypeChange="form.clientType = $event"
                              v-validate="{ required: true }"
                              :status="errors.first('client') ? 'error' : null"
                        />
                        <span class="fs3 lh125 mt1 cError">{{ errors.first("name") }}</span>
                  </div>

                  <!-- Insurance Type -->
                  <div class="xs-12 mt6">
                        <label for="type" class="lh125 mb1 fw7">{{ $t("insurance_type") }}</label>
                        <core-select-insurance-type
                              id="insuranceType"
                              name="insuranceType"
                              v-validate="'required'"
                              :status="errors.first('insuranceType') ? 'error' : null"
                              v-model="form.insuranceType"
                              @input="form.products = []"
                        />
                        <span class="fs3 lh125 mt1 cError">{{ errors.first("insuranceType") }}</span>
                  </div>

                  <!-- Select Product -->
                  <div class="flex wrap xs-12 mt6">
                        <label for="name" class="lh125 fw7 mb1">{{ $t("product") }}</label>
                        <core-select-product
                              id="products"
                              name="products"
                              :insuranceType="form.insuranceType"
                              v-validate="'required'"
                              :status="errors.first('products') ? 'error' : null"
                              v-model="form.products"
                        />
                        <span class="fs3 lh125 mt1 cError">{{ errors.first("products") }}</span>
                  </div>

                  <!-- Start and end date -->
                  <div class="flex wrap mt6">
                        <div class="xs-6 pr2">
                              <label class="fs4 fw7 c1 lh125 mb1" for="startDate">
                                    {{ $t("start_date") }}
                                    <span class="fs3 c6">(DD/MM/YYYY)</span>
                              </label>
                              <j-base-input-text
                                    v-model="form.startDate"
                                    name="startDate"
                                    v-validate="'date_format:DD/MM/YYYY|required'"
                                    :data-vv-as="$t('start_date')"
                                    id="startDate"
                                    :status="errors.first('startDate') ? 'error' : null"
                              />
                              <span
                                    class="fs3 lh125 mt1 cError"
                                    v-if="errors.first('startDate')"
                              >{{ errors.first("startDate") }}</span>
                        </div>
                        <div class="xs-6 pl2">
                              <label class="fs4 fw7 c1 lh125 mb1" for="endDate">
                                    {{ $t("end_date") }}
                                    <span class="fs3 c6">(DD/MM/YYYY)</span>
                              </label>
                              <j-base-input-text
                                    v-model="form.endDate"
                                    name="endDate"
                                    v-validate="'date_format:DD/MM/YYYY|required'"
                                    :data-vv-as="$t('end_date')"
                                    id="endDate"
                                    :status="errors.first('endDate') ? 'error' : null"
                              />
                              <span
                                    class="fs3 lh125 mt1 cError"
                                    v-if="errors.first('endDate')"
                              >{{ errors.first("endDate") }}</span>
                        </div>
                  </div>

                  <!-- Premium and currency -->
                  <div class="flex wrap mt6">
                        <div class="xs-6 pr2">
                              <div class="fs4 fw7 c1 lh125 mb1" for="amount">{{ $t("premium") }}</div>
                              <j-base-input-text
                                    v-model="form.premium.grossAmount"
                                    name="amount"
                                    v-validate="{ decimal: true, required: true }"
                                    :data-vv-as="$t('amount')"
                                    id="amount"
                                    :status="errors.first('amount') ? 'error' : null"
                              />
                              <span
                                    class="fs3 lh125 mt1 cError"
                                    v-if="errors.first('amount')"
                              >{{ errors.first("amount") }}</span>
                        </div>
                        <div class="xs-6 pl2">
                              <div class="fs4 fw7 c1 lh125 mb1" for="currencyCode">{{ $t("currency") }}</div>
                              <core-select-currency
                                    v-model="form.premium.currencyCode"
                                    name="currencyCode"
                                    :data-vv-as="$t('currency')"
                                    id="currencyCode"
                              />
                        </div>
                  </div>

                  <!-- Description -->
                  <div class="xs-12 mt6">
                        <label class="fw7 c1 lh125 mb1" for="description">
                              {{ $t("description") }}
                              <span class="fs3 c6">({{ $t("optional") }})</span>
                        </label>
                        <j-base-input-long-text
                              v-model="form.description"
                              name="description"
                              id="description"
                        />
                  </div>

                  <!-- Buttons -->
                  <div class="mt6">
                        <j-button
                              :isLoading="isLoading"
                              @click="handleSubmit"
                              action="createQuote"
                        >{{ $t("create_quote") }}</j-button>
                  </div>
            </j-card>
      </core-layout-content>
</template>

<script>
import JCard from "@/components/JCard/"
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseInputLongText from "@/components/JBaseInputLongText/"
import JButton from "@/components/JButton/"
import CoreSelectInsurer from "@/modules/core/components/CoreSelectInsurer.vue"
import CoreSelectInsuranceType from "@/modules/core/components/CoreSelectInsuranceType.vue"
import CoreSelectProduct from "@/modules/core/components/CoreSelectProduct.vue"
import CoreSelectCurrency from "@/modules/core/components/CoreSelectCurrency.vue"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"

// TODO: hacking here for Asia
import AsiaApplication from "../components/AsiaApplication"

import CoreSelectClient from "@/modules/core/components/CoreSelectClient.vue"

import { transformDate } from "@/utils/"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		JCard,
		JBaseInputText,
		JBaseInputLongText,
		JButton,
		CoreSelectInsurer,
		CoreSelectInsuranceType,
		CoreSelectProduct,
		CoreSelectCurrency,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreSelectClient,
		AsiaApplication
	},

	data() {
		return {
			isLoading: false,

			form: {
				clientType: "individual",
				holders: [],
				products: [],
				insuranceType: null,
				startDate: null,
				endDate: null,
				description: null,
				premium: {
					grossAmount: null,
					currencyCode: this.$store.state.settings
						.preferredCurrency
				}
			}
		}
	},

	methods: {
		async handleSubmit() {
			// Validate form
			const isValid = await this.$validator.validate()
			if (!isValid) return

			//---------------------------------------
			// 1: Initialize Policy
			// NOTE: For our API, policy without price or product is a quote
			// Product has to be added into offers
			//---------------------------------------
			const tenantId = this.$store.state.tenantId
			const { startDate, endDate, description } = this.form
			const productId = get(this.form, "products[0].productId")
			const holderId = get(this.form, "holders[0].id")
			const premium = get(this.form, "premium")

			this.isLoading = true
			// TODO:
			// We are assuming that holderId is also insured, that's not correct
			// Should be refactored later for proper quote flow
			const res = await api.createQuote({
				policy: {
					holderId,
					insuredIds: [holderId],
					startDate: transformDate(startDate),
					endDate: transformDate(endDate),
					description
				}
			})

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				this.isLoading = false
				return
			}

			//---------------------------------------
			// 2: Add offer to initialized policy
			//---------------------------------------
			const policyId = get(
				res,
				"data.initializePolicy.policyStatus.id"
			)

			const res2 = await api.addOffer({
				tenantId,
				policyId,
				offerInput: { productId, premium }
			})
			this.isLoading = false

			// Don't check errors, just redirect to detail page
			this.$router.push({
				name: "QuoteDetail",
				params: { id: policyId }
			})
		}
	}
}
</script>
